import React, { forwardRef } from "react";

import { cn } from "src/shadcn/lib/utils";
import { Progress as PrimitiveProgress } from "src/primitives/Progress";

export interface ProgressProps extends React.ComponentProps<
  typeof PrimitiveProgress
> {
  /** Custom text to display below the bar (e.g., "3 of 10"). */
  progressValue?: string;
  /** Show percentage text below the bar. */
  showPercentage?: boolean;
  /** Additional CSS class names. */
  className?: string;
}

const Progress = forwardRef<HTMLDivElement, ProgressProps>(
  (
    { progressValue, showPercentage = false, className, value, ...otherProps },
    ref
  ) => {
    const displayText =
      progressValue ?? (showPercentage ? `${value ?? 0}%` : null);

    return (
      <div className={cn("w-full", className)}>
        {displayText && (
          <p className="mb-1.5 text-end text-xs text-muted-foreground">
            {displayText}
          </p>
        )}
        <PrimitiveProgress ref={ref} value={value} {...otherProps} />
      </div>
    );
  }
);

Progress.displayName = "Progress";

export { Progress };
